export const environment = {
  production: false,
  // djangoApiUrl: 'http://localhost:8000/api'
  djangoApiUrl: 'https://delivafasta.com:8082/api'
};
